import React from 'react';
import {
  MasterDetailForm,
  FormSubmitButton,
  Widget,
  FormInput,
  FormSelect,
  Button,
  Row,
  Col,
} from '@digital/ui';
import { ContratoControleQAQC } from '@app/api/contrato';
import * as Yup from 'yup';

interface Props {
  setMedicaoId: React.Dispatch<React.SetStateAction<string | undefined>>;
  medicaoId: string | undefined;
  numeroContrato: any;
  setNumeroContrato: React.Dispatch<React.SetStateAction<undefined>>;
  contrato: ContratoControleQAQC | undefined;
  setContrato: React.Dispatch<React.SetStateAction<ContratoControleQAQC | undefined>>;
  onSearchContrato: () => Promise<void>;
}

const CreateControleQualidadeForm = (props: Props) => {
  const { setMedicaoId, medicaoId, numeroContrato, setNumeroContrato,contrato , setContrato, onSearchContrato } = props;

  return (
    <>
      <MasterDetailForm
        validationSchema={Yup.object().shape(
          {
            medicaoId: Yup.string()
              .required('Uma Medição deve ser selecionada')
          }
        )}
      >
        <Widget title="Cadastro de Controle de Qualidade">
            <Row>
              <Col>
                <label>Numero do Contrato: </label>
              </Col>
              <FormInput
                name="numeroContrato"
                type="text"
                size="small"
                value={numeroContrato}
                onChange={(e: any) => setNumeroContrato(e.target.value)}
                onPressEnter={onSearchContrato}
                span={4}
              />
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={onSearchContrato}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Row>
            <Row>
              {contrato && (
                <Widget 
                  title={`Cadastrar Controle de Qualidade ${contrato.numero} - ${contrato.responsavelFornecedorNome}`}
                  actions={[
                    <FormSubmitButton noIcon={true} type="primary">
                      Criar Controle de Qualidade
                    </FormSubmitButton>,
                  ]}
                >
                  <FormSelect 
                    name='medicaoId'
                    label='Boletins Validos para Controle de Qualidade'
                    value={medicaoId}
                    onChange={e => setMedicaoId(e.toString())}
                    options={contrato && contrato.medicoes.map(item => {
                      return {
                        text: `BM ${item.numero}${(item.pqidentificador) ? " - PQ" + item.pqidentificador : ""}`,
                        value: `${item.id}`
                      }
                    })}
                    span={4}
                  />
                </Widget>
              )}
            </Row>
        </Widget>   
      </MasterDetailForm>
    </>
  );
};

export default CreateControleQualidadeForm;
